module.exports = __webpack_public_path__ + "img/gartentor_2.704094d7.jpg";